var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-header'),_c('router-view'),_c('nav-footer',{attrs:{"phone":this.phone,"name":this.name1,"addr":this.addr,"icp":this.icp}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }